import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SearchService } from 'src/app/shared/services/search.service';
import { AditionalService, Availability } from 'src/app/core/models/availability';
import { StoreInquireService } from 'src/app/shared/services/store-inquire.service';
import { Cruise } from 'src/app/core/models/cruise';
import { CompanyParamsService } from 'src/app/core/services/company-params.service';
import { CruiseServiceAux } from 'src/app/modules/searcher/services/cruise.service';
import { NgWebflowService } from 'ng-webflow';
import { WebFlowAction } from 'src/app/core/enums/web-flow-action.enum';
import { CruiseWrapper } from 'src/app/core/classes/cruise-wrapper';
import { isVisibleRating, isVisibleReview } from 'src/app/plugins/activate-params-system.plugin';
import { MessagesEnum } from 'src/app/core/enums/messages.enum';

@Component({
  selector: 'app-cruise-information-tabs',
  templateUrl: './cruise-information-tabs.component.html',
  styleUrls: ['./cruise-information-tabs.component.scss']
})
export class CruiseInformationTabsComponent implements OnInit {


  @Input() public boatInfo: any;
  @Input() public option: any;
  public amenities_one: any[] = [];
  public amenities_two: any[] = [];
  public collapsedFacilities: any;
  public collapsedGallery: any;
  public collapsedItinerary: boolean = false;
  public collapsedIncludes = false;
  public collapsedNoIncludes = false;
  public collapsedReviews = false;
  public collapsedFaqs = false;
  public featureServices: any[] = [];
  public featureInclude: any[];
  public featureNoInclude: any[];
  itineraryDisclaimer = MessagesEnum.ITINERARY_DISCLAIMER;
  public indexSelected: number = 0;
  public availabilitySelected: Availability | undefined;

  public activatedFaqs: boolean = false;

  public pathCruisePhotos = environment.cruisePhotosPathImg;
  public pathItinerary = environment.itineraryPathImg;
  public galleryImage: string[] = [];
  public imagesItinerary: string[] = [];
  public itineraryGallery: string[] = [];
  public currentImage: number = 0;
  public currentItinerary: number = 0;
  cruiseWrapper!: CruiseWrapper;
  public itinerarySelected: any;

  public fotos: boolean = false;
  public itinerario: boolean = false;
  public incluye: boolean = false;
  public noincluye: boolean = false;
  public review: boolean = false;
  public facilities: boolean = true;
  public faqs: boolean = false;

  public activeLink: string = 'facilities'; // Por defecto, el primer enlace está activo
  public detailViewTemplate?: string;
  private readonly keywords = ['Flight ticket round trip to Galapagos'];

  constructor(
    public searchService: SearchService,
    public cruiseServiceAux: CruiseServiceAux,
    public storeLocalInquireService: StoreInquireService,
    public companyParams: CompanyParamsService,
    private ngWebflowService: NgWebflowService,
  ) {
    this.featureInclude = [];
    this.featureNoInclude = [];
    this.featureServices = [];
  }

  ngOnInit(): void {
    this.detailViewTemplate = this.companyParams.company.headerActions.detailViewTemplate;
    this.chargeBoatData();
    this.fetchAvailability();
    this.chargeAmenities();
    this.reorderComments();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.featureInclude = [];
    this.featureNoInclude = [];
    if (changes['boatInfo'] || changes['option']) {
      this.fetchIncludes(this.boatInfo);
    }
  }
  /**
   * Charge Cruise Data by Input
   */
  chargeBoatData() {
    this.cruiseWrapper = new CruiseWrapper(this.boatInfo);
    this.collapsedFacilities = true;
    this.collapsedGallery = true;
    this.collapsedItinerary = true;
    this.fetchIncludes(this.boatInfo);
    this.collapsedFaqs = true;
    this.galleryImage = this.boatInfo.images;
    this.currentImage = 0;
    this.itineraryGallery = this.boatInfo;

    this.activatedFaqs = this.boatInfo.activatedFaqs || false;
  }

  /**
   * Charge Amenities Info
   */
  chargeAmenities() {
    const amenities_true =
      this.searchService.getRequestFindAvail().amenitiesArray;
    const size = amenities_true ? amenities_true.length : 0;
    this.amenities_one = amenities_true
      ? amenities_true.slice(0, size / 2 + 1)
      : [];
    this.amenities_two = amenities_true
      ? amenities_true.slice(size / 2 + 1, size)
      : [];
  }

  /**
   * Charge Availability Data
   */
  fetchAvailability() {
    this.indexSelected = this.storeLocalInquireService.getIndexAvail();
    this.availabilitySelected =
      this.boatInfo.availability[this.indexSelected];
    const itinerario = this.boatInfo.itineraries.find(
      (iti: any) => iti.code === this.availabilitySelected?.itinerary
    );
    this.itinerarySelected = itinerario;
    this.imagesItinerary = itinerario.images;
    this.currentItinerary = 0;
  }

  /**
   * Search Include/Not include Data
   * @param cruise
   */
  fetchIncludes(cruise: Cruise) {
    this.featureInclude = [];
    this.featureNoInclude = [];
    this.featureServices =
      cruise.availability[this.boatInfo.iterIndex]?.featureServices;
    this.featureServices.forEach((aditionalService: AditionalService) => {
      if (aditionalService.value) {
        if (this.option === 'A') {
          if (!this.isAditionalServiceInKeywords(aditionalService)) {
            this.featureInclude.push(aditionalService);
          }
        } else {
          this.featureInclude.push(aditionalService);
        }

      } else {
        if (this.option === 'A') {
          if (!this.isAditionalServiceInKeywords(aditionalService)) {
            this.featureNoInclude.push(aditionalService);
          }
        } else {
          this.featureNoInclude.push(aditionalService);
        }
      }
    })
  }

  private isAditionalServiceInKeywords(aditionalServices: AditionalService): boolean {
    return this.keywords.some((word) => aditionalServices.name.includes(word));
  }


  next(): void {
    try {
      if (this.currentImage < this.galleryImage.length - 1) {
        this.currentImage++;
      }
    } catch (error) {
      console.error(error);
    }
  }

  prev(): void {
    try {
      if (this.currentImage > 0) {
        this.currentImage--;
      }
    } catch (error) {
      console.error(error);
    }
  }

  selectImage(index: any) {
    this.currentImage = index;
  }

  getItineraries() {
    return this.cruiseServiceAux.createIterDay(this.boatInfo);
  }

  getItineraryDescription(){
    return this.cruiseServiceAux.createIterDescription(this.boatInfo);
  }

  addLogsNavInfo(nameTab: string) {
    this.ngWebflowService.addWebFlowAction(
      WebFlowAction.NAV_CRUISE_INFO_ + nameTab.toUpperCase(),
      {
        nameBoat: this.cruiseWrapper?.getName(),
        itinerarySelected: this.cruiseWrapper?.getCurrentItineraryForLogs(),
      }
    );
  }

  isVisibleReview(): boolean {
    return isVisibleReview(this.boatInfo);
  }

  isVisibleRating(): boolean {
    return isVisibleRating(this.boatInfo);
  }

  reorderComments() {
    let defaultIndex = this.cruiseWrapper.getMainComent();
    if (this.boatInfo.comments.length > 0) {
      this.boatInfo.comments.forEach((comment: any, i: number) => {
        if (comment.code == defaultIndex) {
          this.boatInfo.comments.splice(i, 1);
          this.boatInfo.comments.unshift(comment);
        }
      })
    }
  }

  ngComponent(): void {
    this.verfotos();
    this.veritinerario();
    this.verincluye();
    this.vernoincluye();
    this.verreview();
    this.verfacilites();
    this.verfaqs();
  }

  verfotos() {
    this.fotos = !this.fotos;
    if (this.fotos) {
      this.itinerario = false
      this.incluye = false
      this.noincluye = false
      this.review = false
      this.facilities = false;
      this.faqs = false;
      this.activeLink = 'photos';
    }
  }

  veritinerario() {
    this.itinerario = !this.itinerario;
    if (this.itinerario) {
      this.fotos = false
      this.incluye = false
      this.noincluye = false
      this.review = false
      this.facilities = false;
      this.faqs = false;
      this.activeLink = 'itinerary';
    }
  }

  verincluye() {
    this.incluye = !this.incluye;
    if (this.incluye) {
      this.itinerario = false
      this.fotos = false
      this.noincluye = false
      this.review = false
      this.facilities = false;
      this.faqs = false;
      this.activeLink = 'included';
    }
  }

  vernoincluye() {
    this.noincluye = !this.noincluye;
    if (this.noincluye) {
      this.itinerario = false
      this.fotos = false
      this.incluye = false
      this.review = false
      this.facilities = false;
      this.faqs = false;
      this.activeLink = 'notIncluded';
    }
  }

  verreview() {
    this.review = !this.review;
    if (this.review) {
      this.itinerario = false
      this.fotos = false
      this.incluye = false
      this.noincluye = false
      this.facilities = false;
      this.faqs = false;
      this.activeLink = 'reviews';
    }
  }

  verfacilites() {
    this.facilities = !this.facilities;
    if (this.facilities) {
      this.itinerario = false
      this.fotos = false
      this.incluye = false
      this.noincluye = false
      this.review = false
      this.faqs = false;
      this.activeLink = 'facilities';
    }
  }

  verfaqs() {
    this.faqs = !this.faqs;
    if (this.faqs) {
      this.itinerario = false
      this.fotos = false
      this.incluye = false
      this.noincluye = false
      this.review = false
      this.facilities = false;
      this.activeLink = 'faqs';
    }
  }
}
